<template>
  <article class="obra-chapter-card" role="button" tabindex="0" :aria-label="`Abrir capitulo ${chapterTitle}`" @click="$emit('open', chapter)" @keydown.enter.self.prevent="$emit('open', chapter)" @keydown.space.self.prevent="$emit('open', chapter)">
    <div class="obra-chapter-card__thumb">
      <img v-if="thumbnail" :src="thumbnail" :alt="`Imagem do capitulo ${chapterTitle}`" @contextmenu.prevent />
      <v-icon v-else color="#d9d9d9">mdi-book-open-page-variant</v-icon>
    </div>
    <div class="obra-chapter-card__content">
      <h3>{{ chapterTitle }}</h3>
      <div class="obra-chapter-card__meta">
        <span v-if="showSocialMeta"><v-icon size="16" color="#d9d9d9">mdi-comment</v-icon>{{ chapter.comments || 0 }}</span>
        <span v-if="showSocialMeta"><v-icon size="16" color="#d9d9d9">mdi-eye</v-icon>{{ formatViews(chapter.views) }}</span>
        <span v-if="showSocialMeta"><v-icon size="16" color="#d9d9d9">mdi-heart</v-icon>{{ chapter.likes_count || 0 }}</span>
        <span v-if="chapter.status === 'agendado'" class="obra-chapter-card__date">Agendado para {{ formatScheduledAt(chapter.scheduled_at) }}</span>
        <span v-else-if="chapter.status === 'publicado'" class="obra-chapter-card__date">Publicado {{ formatDate(chapter.published_at || chapter.release_date || chapter.publication_date) }}</span>
        <span v-else-if="chapter.status === 'rascunho'" class="obra-chapter-card__date">Não publicado</span>
        <span v-else-if="chapter.release_date" class="obra-chapter-card__date">Publicado {{ formatDate(chapter.release_date) }}</span>
        <span v-else-if="chapter.publication_date" class="obra-chapter-card__date">Publicado {{ formatDate(chapter.publication_date) }}</span>
        <span v-if="chapter.description" class="obra-chapter-card__description">{{ chapter.description }}</span>
      </div>
    </div>
    <div class="obra-chapter-card__actions">
      <v-btn v-if="showLike" icon class="obra-chapter-card__icon" :aria-label="chapter.is_like ? 'Remover curtida do capitulo' : 'Curtir capitulo'" @click.stop="$emit('like', chapter)">
        <v-icon color="white">{{ chapter.is_like ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
      </v-btn>
      <v-btn v-if="isAdmin" icon class="obra-chapter-card__icon zinnes-primary-btn" aria-label="Editar capitulo" @click.stop="$emit('open', chapter)">
        <v-icon color="var(--zinnes-primary)">mdi-pencil</v-icon>
      </v-btn>
      <v-btn v-if="isAdmin" icon class="obra-chapter-card__icon" color="red" aria-label="Excluir capitulo" @click.stop="$emit('delete', chapter)">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </div>
  </article>
</template>

<script>
import { formatScheduledAt, parseScheduledAt } from '@/utils/scheduling';

export default {
  name: 'ObraChapterCard',
  props: {
    chapter: { type: Object, required: true },
    projectThumb: { type: String, default: '' },
    isAdmin: { type: Boolean, default: false },
    showLike: { type: Boolean, default: true },
    showSocialMeta: { type: Boolean, default: true },
  },
  computed: {
    chapterTitle() {
      return this.chapter.name || (this.chapter.number ? `Capitulo ${this.chapter.number}` : 'Capitulo sem titulo');
    },
    thumbnail() {
      return this.chapter.title_thumb || this.chapter.thumb || this.projectThumb || '';
    },
  },
  methods: {
    formatScheduledAt(value) {
      return formatScheduledAt(value);
    },
    formatViews(views) {
      const value = Number(views || 0);
      if (value >= 1000000) return `${(value / 1000000).toFixed(value >= 10000000 ? 0 : 1)}M`;
      if (value >= 1000) return `${(value / 1000).toFixed(value >= 10000 ? 0 : 1)}k`;
      return String(value);
    },
    formatDate(date) {
      if (!date) return '';
      const parsed = parseScheduledAt(date);
      if (parsed.date) {
        const [y, m, d] = parsed.date.split('-');
        return `${d}/${m}/${y}`;
      }
      const parsedDate = new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return date;

      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(parsedDate);
    },
  },
};
</script>
